/**
 * 入力画面の並べ方（Issue #470）。**同じページ・同じ状態・同じ部品のまま、画面の広さで並べ方だけ変える**。
 *   compact: スマホの縦画面（上半分が表示・下半分がタブ。Issue #467 のまま）
 *   wide:    横長で幅 1000px 以上。左に盤面 + 再生バー、右に 応答 / 登録 / 発話 のタブ
 *   both:    幅 1500px 以上。応答と、登録か発話を並べる（右の列は 登録 / 発話 のタブ）
 * フィールド動画は縦長（1080×2100）なので、横長の画面では盤面は高さで頭打ちになり横が余る。余った横にパネルを並べる。
 * matchMedia の無い環境（jsdom）では compact。
 */
import useMediaQuery from '../useMediaQuery';

export const WIDE_MIN_W = 1000;
export const BOTH_MIN_W = 1500;
const LANDSCAPE = '(min-aspect-ratio: 1/1)';
export const WIDE_QUERY = `(min-width: ${WIDE_MIN_W}px) and ${LANDSCAPE}`;
export const BOTH_QUERY = `(min-width: ${BOTH_MIN_W}px) and ${LANDSCAPE}`;

export const layoutOf = ({ wide, both }) => (wide ? (both ? 'both' : 'wide') : 'compact');

export default function useInputLayout() {
  const wide = useMediaQuery(WIDE_QUERY);
  const both = useMediaQuery(BOTH_QUERY);
  return layoutOf({ wide, both });
}

/**
 * どのパネルを出すか。compact は今のタブ 1 つ、wide は再生タブが無い（再生バーが常に出ている）ので 応答 / 登録 / 発話 のどれか、
 * both は応答を常に出し、右の列を 登録 / 発話 で切り替える。
 * @returns {{ play: boolean, respond: boolean, register: boolean, speech: boolean }}
 */
export function visiblePanels(layout, tab) {
  if (layout === 'compact') return { play: tab === 'play', respond: tab === 'respond', register: tab === 'register', speech: tab === 'speech' };
  if (layout === 'both') return { play: false, respond: true, register: tab !== 'speech', speech: tab === 'speech' };
  return { play: false, respond: tab !== 'register' && tab !== 'speech', register: tab === 'register', speech: tab === 'speech' };
}
